import React, { useEffect, useRef } from 'react';
import { X } from 'lucide-react';
interface FilterDropdownProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  onApply: () => void;
  onClear: () => void;
  triggerRef: React.RefObject<HTMLButtonElement>;
}
export function FilterDropdown({
  isOpen,
  onClose,
  children,
  onApply,
  onClear,
  triggerRef
}: FilterDropdownProps) {
  const dropdownRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node) && triggerRef.current && !triggerRef.current.contains(event.target as Node)) {
        onClose();
      }
    };
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onClose, triggerRef]);
  if (!isOpen) return null;
  return <div ref={dropdownRef} className="absolute right-0 top-full mt-2 bg-white rounded-xl shadow-xl border border-gray-200 w-80 z-50" data-id="element-56">
      <div className="flex items-center justify-between p-4 border-b border-gray-200" data-id="element-57">
        <h3 className="text-lg font-bold text-gray-900" data-id="element-58">Filtros</h3>
        <button onClick={onClear} className="text-sm text-red-600 hover:text-red-700 font-medium" data-id="element-59">
          Limpar
        </button>
      </div>
      <div className="p-4 max-h-96 overflow-y-auto" data-id="element-60">{children}</div>
      <div className="p-4 border-t border-gray-200" data-id="element-61">
        <button onClick={onApply} className="w-full px-4 py-2 bg-[#8BC4C3] text-white rounded-lg hover:bg-[#6BABA9] transition-colors font-medium" data-id="element-62">
          Aplicar Filtros
        </button>
      </div>
    </div>;
}